/**
 * Dummy function for commonCoreSdk
 * @example - TBD
 * @returns - TBD
 */
export function commonCoreSdk(): string {
  return 'common-core-sdk';
}
